<template>
    <b-modal
      id="modal-product-filter"
      ok-title="Submit"
      cancel-variant="outline-secondary"
      title="過瀘"
      title-class="font-weight-bolder"
      body-class="common_modal modal_visible"
      hide-footer
      no-close-on-backdrop
      size="sm"
      centered
    >
     
      <b-overlay
        :show="loading"
        spinner-variant="primary"
        spinner-type="grow"
        spinner-small
        rounded="sm"
      >
        <b-form class="mt-1" @submit.prevent="onSubmit">
          <b-row>
            <b-col cols="12">
              <b-form-group
                label="狀態："
                label-for="productStatusFilter"
                label-cols-md="3"
              >
                <v-select
                  id="productStatusFilter"
                  v-model="update.productStatusFilter"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="productStatuses"
                  label="name"
                  :reduce="(option) => option.id"
                  placeholder="選擇狀態"
                  :filter="productStatusSearch"
                >
                </v-select>
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group
                label="商品分類："
                label-for="productCategoryFilter"
                label-cols-md="3"
              >
                <v-select
                  id="productCategoryFilter"
                  v-model="update.productCategoryFilter"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="productCategories"
                  label="name"
                  :reduce="(option) => option.id"
                  placeholder="選擇商品分類"
                  :filter="productCategorySearch"
                >
                </v-select>
              </b-form-group>
            </b-col>
          </b-row>
          <div class="d-flex mt-2 justify-content-end">
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              variant="outline-secondary"
              @click="update = {}"
              class="mr-1"
            >
              重置
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-danger"
              class="mr-1"
              @click="hide"
            >
              取消
            </b-button>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              type="submit"
            >
              <feather-icon size="16" class="mr-1" icon="CheckCircleIcon" />
              提交
            </b-button>
          </div>
        </b-form>
      </b-overlay>
    </b-modal>
  </template>
  
  <script>
  import {
    BButton,
    BModal,
    VBModal,
    BCardText,
    BOverlay,
    BForm,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BCard,
    BCardBody,
  } from "bootstrap-vue";
  import vSelect from "vue-select";
  import Ripple from "vue-ripple-directive";
  import flatPickr from "vue-flatpickr-component";
  
  export default {
    components: {
      BButton,
      BModal,
      VBModal,
      BCardText,
      BOverlay,
      BForm,
      BFormGroup,
      BFormInput,
      BRow,
      BCol,
      BCardBody,
      BCard,
      vSelect,
      flatPickr,
    },
    directives: {
      "b-modal": VBModal,
      Ripple,
    },
    methods: {
      hide() {
        this.$bvModal.hide("modal-product-filter");
      },
      productStatusSearch(options, search) {
        return options.filter((item) => {
          return item.name.toLowerCase().includes(search.toLowerCase());
        });
      },
      productCategorySearch(options, search) {
        return options.filter((item) => {
          return item.name.toLowerCase().includes(search.toLowerCase());
        });
      },
      onSubmit() {
        this.$emit("update:productCategoryFilter", this.update.productCategoryFilter);
        this.$emit("update:productStatusFilter", this.update.productStatusFilter);
        this.hide();
      },
    },
    props: {
        productCategories: {
        type: Array,
        required: true,
      },
      productStatuses: {
        type: Array,
        required: true,
      },

    },
    data() {
      return {
        loading: false,
        update: {
            productCategoryFilter:null,
            productStatusFilter:null,
        },

      };
    },
  };
  </script>
  
  <style lang="scss">
  @import "@core/scss/vue/libs/vue-select.scss";
  @import "@core/scss/vue/libs/vue-flatpicker.scss";
  </style>
  